import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader";
import { uploadDocument } from "../../store/reducers/uploadDocumentSlice";

const DROPBOX_APP_KEY = process.env.REACT_APP_DROPBOX_APP_KEY;

const DropboxPicker = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);

  useEffect(() => {
      if (!window.Dropbox) {
        const script = document.createElement("script");
        script.id = "dropboxjs";
        script.src = "https://www.dropbox.com/static/api/2/dropins.js";
        script.dataset.appKey = DROPBOX_APP_KEY;
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => {
        };
      }
  }, []);

  const handleFilePicker = () => {
    if (!window.Dropbox) {
      alert("Dropbox is not loaded yet. Please refresh and try again.");
      return;
    }

    const options = {
      success: async (files) => {
        console.log("Selected File:", files);
        const fileUrl = files[0].link;
        const fileName = files[0].name;
        downloadAndUpload(fileUrl, fileName);
      },
      cancel: () => {
        console.log("User canceled file selection.");
      },
      linkType: "direct",
      multiselect: false,
      folderselect: false,
      extensions: ['.pdf'],
    };

    window.Dropbox.choose(options);
  };
      

  const downloadAndUpload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const fileBlob = await response.blob();
      uploadToServer(fileBlob, fileName);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const uploadToServer = async (file, fileName) => {
    const formData = new FormData();
    formData.append("file", file, fileName);
    try {
      setLoader(true)
      dispatch(uploadDocument({ token: pdfEditortoken?.access, file, fileName:fileName  }));
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  return (<>
    <Box textAlign="center" onClick={handleFilePicker} sx={{ cursor: "pointer" }}>
        <Box component="img" src={`${process.env.PUBLIC_URL}/images/dropbox.svg`} alt="Dropbox" />
        <Typography variant="body1" fontSize={14} fontWeight={500} mt={1}  color='#222222'>
            Dropbox
        </Typography>
    </Box>
    {loader && < Loader />}
    </>
  );
};

export default DropboxPicker;
